import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {toast} from "react-toastify";
import config from "../../config/apiService.json";
import {fetchDataWithAuth} from "../../utils/fetchData";
import {imageFileTypeValidation, validateImageSize} from "../../utils/imageValidation";
import {patchMethod, postMethod} from "../../utils/httpServices";

const UseUpdateMediaEevent = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [isLoading, setLoading] = useState(false);
    const [iconFile, setIconFile] = useState();
    const [imageFile, setImageFile] = useState();
    const detailDescriptionEditor = useRef();

    const {administrative} = config;
    const {mediaEvents} = administrative;

    const getData = async () => {
        if (parseInt(id) !== 0) {
            const result = await fetchDataWithAuth(`${mediaEvents}/${id}`);
            setData(result);
        } else {
            const demoObj = {
                shortDescription: "",
                detailDescription: "",
                smallImageBase64: "",
                detailImageBase64: ""
            }
            // console.log(demoObj);
            setData(demoObj);
        }
        setLoading(false);
    }

    const handleIconChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            let imageSizeValidityResult = validateImageSize(file, 300);
            let imageValidityResult = imageFileTypeValidation(file);

            if (imageSizeValidityResult === true && imageValidityResult === true) {
                setIconFile(file);
                updateIconAndImage(file, "smallImageBase64");
            }
        }
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            let imageSizeValidityResult = validateImageSize(file, 1024);
            let imageValidityResult = imageFileTypeValidation(file);

            if (imageSizeValidityResult === true && imageValidityResult === true) {
                setImageFile(file);
                updateIconAndImage(file, "detailImageBase64");
            }
        }
    }

    const updateIconAndImage = (file, prop) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
            let base64 = reader.result.replace(`data:${file.type};base64,`, "");
            setData({...data, [prop]: base64});
        };
    }

    const handleShortDescriptionChange = (e) => {
        setData({...data, shortDescription: e.target.value});
        if (e.target.value.length >= 150) toast.warn("Maximum 150 characters!")
    }

    const handleUpdate = async () => {
        const formData = new FormData();
        iconFile && formData.append('smallImage', iconFile);
        formData.append('shortDescription', data.shortDescription);
        formData.append('detailDescription', detailDescriptionEditor.current.getContent());
        imageFile && formData.append('detailImage', imageFile);

        try {
            if (parseInt(id) !== 0) {
                const response = await patchMethod(`${mediaEvents}/${id}`, formData);
                if (response) {
                    toast.success("Media & Event Updated!");
                    setIconFile(null);
                    setImageFile(null);
                    navigate("/admin/media-events");
                }
            } else {
                const response = await postMethod(`${mediaEvents}`, formData);
                if (response) {
                    toast.success("Media & Event Added!");
                    setIconFile(null);
                    setImageFile(null);
                    navigate("/admin/media-events");
                }
            }
        } catch (ex) {
            toast.error(ex.response.data);
        }
    }

    useEffect(() => {
        getData();
    }, []);

    return {
        data,
        isLoading,
        handleIconChange,
        handleShortDescriptionChange,
        handleImageChange,
        handleUpdate,
        detailDescriptionEditor
    }
};

export default UseUpdateMediaEevent;
